import { useHeaderMenuContext } from '@/creditflowresearch/application/HeaderMenu/HeaderMenuContext';
import { useArticlesThemesContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesMarketThemesContext';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import {
  getRegionsByIdsFromDictionary,
  getRegionsIdFromThemes,
} from '@/creditflowresearch/ui/components/creditFlow/articles/helpers';

const RegionCell = ({ row }) => {
  const { regions: regionsList } = useHeaderMenuContext();
  const {
    themes,
    isInitialized: isThemesInitialized,
  } = useArticlesThemesContext();

  if (!isThemesInitialized) {
    return '-';
  }

  const regionIds = getRegionsIdFromThemes(themes, row.themes);
  const regions = getRegionsByIdsFromDictionary(regionIds, regionsList);

  if (!regions.length) {
    return '-';
  }

  const regionsAbbreviations = regions.map((region: IRegion) => region.abbreviation).sort();

  if (regionsAbbreviations.length <= 2) {
    return regionsAbbreviations.join(', ');
  }

  return (
    <Tooltip
      content={ regionsAbbreviations.join(', ') }
    >
      { regionsAbbreviations.slice(0, 2)
        .join(', ') }, ...
    </Tooltip>
  );
};

export default RegionCell;
